import React from 'react';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage: React.FC = () => {
    return (
        <div className="privacy-policy-page">
            <h1 className="privacy-title">개인정보처리방침</h1>

            <p>주식회사 부릉라이더스(이하 '회사')은 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등 관련 법령(이하 "관련 법령" 이라 함)에 따라 이용자의 개인정보를 보호하고, 이와 관련한 고충을 신속하고
                원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침을 수립합니다.</p>
            <p>개인정보처리방침은 이용자가 언제나 쉽게 열람할 수 있도록 서비스 초기화면을 통해 공개하고 있으며, 개인정보 관련법령, 지침, 고시 또는 회사 정책의 변경에 따라 변경될 수 있습니다.</p>

            {/* ── 1. 개인정보의 수집·이용 ── */}
            <h2 className="privacy-section-title">1. 개인정보의 수집·이용</h2>
            <p>회사는 서비스 제공을 위해 필요한 최소한의 정보만을 수집·이용하며, 이용자의 권리·이익이나 사생활을 뚜렷하게 침해할 우려가 있는 정보(사상 및 신조, 정치적 성향이나 기타 사회활동 경력 등)는 수집하지 않습니다.
                수집·이용목적이 변경되는 경우에는 "관련 법령"에 따라 별도의 동의를 받는 등 필요한 조치를 이행합니다.</p>
            <p>회사는 다음과 같이 개인정보를 수집하여 이용 및 보유합니다.</p>

            <h3 className="privacy-sub-title">1. 부릉라이더스(VROONGRIDERS) 서비스 이용자</h3>

            <h4 className="privacy-sub-title2">1-1. 정보주체의 동의 없이 처리하는 개인정보</h4>
            <p>개인정보보호법 제15조제1항제4호 (계약 체결 및 이행)</p>
            <ul>
                <li>▷ 서비스 제공에 관한 계약 이행 (성명, 휴대폰번호, 주소, 이메일, 사업자등록번호, 아이디(ID), 비밀번호)</li>
                <li>▷ 서비스 제공에 따른 요금정산 (예금주명, 은행명, 계좌번호, 가상 계좌번호, 가상계좌 예금주명)</li>
            </ul>
            <p>고용보험법 제77조의7 (노무제공플랫폼사업자에 대한 특례)</p>
            <ul>
                <li>▷ 고용보험 관련 신고 및 납부 (성명, 주민등록번호(외국인인 경우 외국인 등록번호))</li>
                <li>▶ 계약 해지시까지 보관</li>
            </ul>

            <h4 className="privacy-sub-title2">1-2. 정보주체의 동의를 받아 처리하는 개인정보</h4>
            <p>개인정보보호법 제15조제1항제1호 (정보주체의 동의)</p>
            <ul>
                <li>▷ 부릉라이더스 vpay 가입시 부릉 프렌즈 서비스 가입, 라이더 등록 및 운영 (본인인증 정보(이름,생년월일,전화번호) 주소, 아이디, 비밀번호, 운송 수단, 활동지역, 실계좌 예금주, 실계좌 은행, 실계좌번호)</li>
                <li>▷ 배달 과정에서 발생할 수 있는 라이더 문의에 응대하고 사고 발생에 따른 처리 지원 (비상연락망, 차량번호, 성별, 운행정보, 면허종류)</li>
                <li>▷ 불법 및 부정 이용 방지 (성명, 생년월일, 휴대폰번호, CI(연계정보), 아이디(ID), 운행정보, 위치정보, 차량번호, 면허종류, 운전면허종별, 범죄경력, 예금주명, 은행명, 계좌번호)</li>
                <li>▶ 회원 탈퇴 1개월 후 파기(단, 생활물류서비스 산업발전법에 따라 보관이 필요한 경우 실효기간까지 보관)</li>
            </ul>

            <h3 className="privacy-sub-title">2. 보유기간 예외 사유</h3>
            <p>회사는 다음의 사유에 해당하는 경우에는 명시한 기간 이외에 해당 사유 종료 시까지 보유 및 이용할 수 있습니다.</p>
            <ul>
                <li>관계 법령 위반에 따른 수사·조사 등이 진행중인 경우 : 해당 수사·조사 종료 시까지</li>
                <li>서비스 이용에 따른 채권·채무관계가 잔존하는 경우 : 채권·채무관계 정산 시까지</li>
                <li>원천징수세 납부 기록의 보관을 위하여 필요한 경우: 법정신고기한이 지난 날로부터 5년까지</li>
                <li>기타 관련 법령에 따라 보유하는 경우</li>
            </ul>

            {/* ── 이미지 대체 표 ── */}
            <table className="privacy-table">
                <thead>
                <tr>
                    <th>사유</th>
                    <th>보존이유</th>
                    <th>보존기간</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>전자금융 거래에 관한 기록</td>
                    <td>전자금융거래법</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td>대급결제 및 재화 등의 공급에 관한 기록</td>
                    <td rowSpan={4}>전자상거래등에서의 소비자보호에 관한 법률</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td>계약 또는 청약철회등에 관한 기록</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td>소비자의 불만 및 분쟁처리에 관한 기록</td>
                    <td>3년</td>
                </tr>
                <tr>
                    <td>표시·광고에 관한기록</td>
                    <td>6개월</td>
                </tr>
                <tr>
                    <td>홈페이지 방문기록</td>
                    <td>통신비밀보호법</td>
                    <td>3개월</td>
                </tr>
                <tr>
                    <td>회사 내부정책</td>
                    <td>계약 종료 후 고충처리 및 불량회원 재가입 방지를 위하여 필요한 경우</td>
                    <td>계약 종료 후 1년</td>
                </tr>
                </tbody>
            </table>

            <p>또한, 서비스 이용과정에서 아래와 같은 정보들이 자동으로 생성 및 기록될 수 있습니다.</p>
            <ul>
                <li>서비스 이용기록, 접속로그, 쿠키정보, 접속IP 정보, MAC정보, 결제기록, 운영체제 종류 및 버전, 브라우저정보, 기기정보, 광고식별자, 위치정보</li>
            </ul>

            {/* ── 2. 개인정보처리의 위탁 ── */}
            <h2 className="privacy-section-title">2. 개인정보처리의 위탁에 관한 사항</h2>
            <p>회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
            <table className="privacy-table">
                <thead>
                <tr>
                    <th>수탁사</th>
                    <th>위탁업무</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Amazon Web Service</td>
                    <td>클라우드 서비스를 이용한 시스템 운영 및 데이터 보관</td>
                </tr>
                <tr>
                    <td>중소기업은행</td>
                    <td>가상 계좌 개설, 예치금 예치</td>
                </tr>
                </tbody>
            </table>

            {/* ── 3. 제3자 제공 ── */}
            <h2 className="privacy-section-title">3. 개인정보의 제3자 제공에 관한 사항</h2>
            <p>회사는 이용자의 개인정보를 수집 및 이용목적 범위 내에서 처리하며, 이용자의 사전 동의없이 동범위를 초과하여 이용하거나 이용자의 개인정보를 제3자에게 제공하지 않습니다.</p>
            <p>다만, 다음의 경우는 이용자의 정보를 제공할 수 있습니다.</p>
            <ul>
                <li>이용자로부터 별도의 동의를 받은 경우</li>
                <li>법원의 제출명령 또는 법관이 발부한 영장에 따라 수사상의 목적으로 공공기관으로부터 요구가 있을 경우</li>
                <li>통계작성, 학술연구나 시장조사를 위하여 특정 개인을 식별할 수 없는 형태로 연구단체 등에 제공하는 경우</li>
                <li>공공기관 등으로부터 관계법령에서 정한 절차에 따른 요청이 있을 경우</li>
            </ul>

            {/* ── 4. 파기절차 및 방법 ── */}
            <h2 className="privacy-section-title">4. 개인정보의 파기절차 및 파기방법</h2>
            <p>회사는 원칙적으로 개인정보 보유기간의 경과, 개인정보의 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기하고 있습니다.</p>
            <p>개인정보 보유기간이 경과하거나 수집 및 이용목적이 달성되었음에도 불구하고 내부규정 및 관련 법령에 의한 정보보호 사유(이용 및 보유기간 참조)에 따라 개인정보를 계속 보관하여야 하는 경우에는, 해당 개인정보를 별도 DB에 옮기고 일정 기간
                보관된 후 파기됩니다.</p>
            <p>별도 DB로 옮겨진 개인정보는 관련 법령에 의한 경우를 제외하고는 다른 목적으로 이용되지 않습니다.</p>
            <p>개인정보의 파기절차 및 방법은 다음과 같습니다.</p>
            <ul>
                <li>파기절차 : 회사는 파기 사유가 발생한 개인정보를 선정하고 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</li>
                <li>파기방법 : DB 등 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없는 기술적 방법으로 파기하고, 종이 문서에 작성·출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</li>
            </ul>

            {/* ── 5. 이용자 권리 ── */}
            <h2 className="privacy-section-title">5. 이용자와 법정대리인의 권리·의무 및 그 행사방법에 관한 사항</h2>
            <p>정보주체는 회사에 대해 언제든지 다음 각 사항에 대한 권리를 행사할 수 있습니다. 회사는 만 14세 미만의 아동의 개인정보는 처리하지 않습니다.</p>
            <ul>
                <li>개인정보 열람 요구</li>
                <li>오류 등이 있을 경우 정정 요구</li>
                <li>개인정보 삭제 요구</li>
                <li>개인정보 동의철회(처리정지) 요구</li>
            </ul>
            <p>정보주체의 권리 행사는 회사에 대해 ｢개인정보 보호법 시행령｣ 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.</p>
            <p>정보주체의 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 ｢개인정보 처리 방법에 관한 고시(제2023-12호)｣ 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
            <p>개인정보 열람 및 처리정지 요구는 ｢개인정보 보호법｣ 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.</p>
            <p>개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
            <p>정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</p>
            <p>정보주체는 본인의 개인정보를 항상 최신화하여 불의의 사고를 사전에 예방하여야 합니다. 부정확한 정보의 입력으로 인해 발생하는 사고의 책임은 정보주체에게 있으며, 타인 정보의 도용 등 허위정보를 입력할 경우
                이용자격이 상실될 수 있습니다.</p>
            <p>정보주체는 접속정보(ID, 패스워드 등)를 포함한 본인의 개인정보가 유출되지 않도록 공용 PC 사용 시 반드시 로그아웃을 하는 등 기본적인 주의를 기울여야 하고 다른 사람이 추측할 수 있는 쉬운 비밀번호는 사용을 피하여야
                하며, 정기적으로 비밀번호를 변경하는 것이 바람직합니다.</p>
            <p>정보주체는 게시물을 포함한 타인의 개인정보 및 권리를 침해, 훼손하지 않도록 유의하여야 합니다. 정보주체가 관계 법령을 위반하여 타인의 개인정보 및 권리를 침해, 훼손할 시에는 법적 책임이 따를 수 있습니다.</p>

            {/* ── 6. 행태정보 ── */}
            <h2 className="privacy-section-title">6. 개인정보 자동수집장치를 통한 행태정보의 수집·이용 및 거부에 관한 사항</h2>
            <p>회사는 서비스 이용과정에서 정보주체에게 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등을 제공하기 위하여 행태정보를 수집·이용하고 있습니다. 이 경우에도 개인식별정보와 결합하여 이용되지 않습니다.</p>
            <p>행태정보 수집안내</p>
            <table className="privacy-table">
                <thead>
                <tr>
                    <th>내용</th>
                    <th>상세</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>수집 항목</td>
                    <td>이용자의 웹사이트/앱 서비스 방문이력, 검색이력, 구매이력</td>
                </tr>
                <tr>
                    <td>수집 방법</td>
                    <td>이용자의 웹사이트 및 앱 방문/실행 시 자동 수집</td>
                </tr>
                <tr>
                    <td>수집 목적</td>
                    <td>이용자의 관심, 성향에 기반한 개인 맞춤형 상품추천서비스(광고 포함)를 제공</td>
                </tr>
                <tr>
                    <td>보유·이용기간 및 이후 정보처리 방법</td>
                    <td>회원탈퇴 후 즉시파기</td>
                </tr>
                </tbody>
            </table>

            <h3 className="privacy-sub-title">1. 행태정보 수집 거부 (모바일 앱)</h3>
            <p>회사는 모바일 앱에서 온라인 맞춤형 광고를 위하여 광고식별자를 수집·이용합니다. 이용자는 모바일 단말기의 설정 변경을 통해 앱의 맞춤형 광고를 차단·허용할 수 있습니다. 단, 모바일 OS 버전에 따라 메뉴 및 방법이 다소
                상이할 수 있습니다.</p>
            <ul>
                <li>안드로이드 : 설정 &gt; 보안 및 개인정보 보호 &gt; 개인정보보호 &gt; 기타설정 &gt; 광고 &gt; 광고 ID 재설정 또는 광고 ID 삭제</li>
                <li>아이폰 : 설정 &gt; 개인정보보호 및 보안 &gt; 추적 &gt; 앱이 추적을 요청하도록 허용 끔</li>
            </ul>

            <h3 className="privacy-sub-title">2. 행태정보 수집 거부 (웹브라우저)</h3>
            <p>이용자는 웹브라우저의 쿠키 설정 변경 등을 통해 온라인 맞춤형 광고를 일괄적으로 차단·허용할 수 있습니다. 단, 쿠키 설정 변경은 웹사이트 자동로그인 등 일부 서비스의 이용에 영향을 미칠 수 있습니다.</p>
            <ul>
                <li>Microsoft Edge : 웹 브라우저 우측 상단의 아이콘 "…" 선택 &gt; "설정" 선택 &gt; "개인정보, 검색 및 서비스" 선택 &gt; "추적방지" 섹션 내 '추적방지' 여부 및 수준 &gt; 'InPrivate를 검색할 때 항상 "엄격" 추적
                    방지 사용' &gt; '개인정보' 섹션 내 '추적 안함 요청보내기'</li>
                <li>Chrome : 웹 브라우저 우측 상단의 아이콘 "︙" 선택 &gt; "설정" 선택 &gt; "개인정보 및 보안" 선택 &gt; "사이트 설정" 선택 &gt; "서드 파티 쿠키" 선택 &gt; 직접 설정</li>
            </ul>

            <h3 className="privacy-sub-title">3. 쿠키정보 수집 거부 (웹브라우저)</h3>
            <p>회사는 정보주체에게 개별적인 맞춤서비스를 제공하기 위하여 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버(http)가 정보주체의 컴퓨터 브라우저에게 보내는
                소량의 정보이며, 정보주체의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.</p>
            <ul>
                <li>Microsoft Edge : 웹 브라우저 상단의 "설정" 메뉴 &gt; "개인 정보, 검색 및 서비스" 메뉴 &gt; "검색 데이터 지우기" 선택 &gt; 직접 설정</li>
                <li>Chrome : 웹 브라우저 우측 상단의 아이콘 "︙" 선택 &gt; "설정" 선택 &gt; "개인정보 및 보안" 선택 &gt; "사이트 설정" 선택 &gt; "서드파티 쿠키" 선택 &gt; "모든 사이트 데이터 및 권한보기"를 선택 &gt; 직접
                    설정</li>
            </ul>

            <h3 className="privacy-sub-title">4. 정보주체는 아래의 연락처로 행태정보와 관련하여 궁금한 사항과 거부권 행사, 피해 신고 접수 등을 문의할 수 있습니다.</h3>
            <ul>
                <li>부서 : 3PL사업팀</li>
                <li>전화번호 : 010-9630-2068</li>
                <li>이메일 : license@vroongriders.com</li>
            </ul>

            {/* ── 7. 안전성 확보조치 ── */}
            <h2 className="privacy-section-title">7. 개인정보의 안전성 확보조치</h2>
            <p>회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성을 확보하기 위하여 다양한 기술적/관리적 대책을 마련하고 있습니다.</p>

            <h3 className="privacy-sub-title">1. 기술적 보호조치</h3>
            <ul>
                <li>이용자의 개인정보는 비밀번호에 의해 보호되며 파일 및 전송데이터를 암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.</li>
                <li>회사는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로 업데이트되며 갑작스러운 바이러스가 출현할 경우 백신이 나오는 즉시 이를
                    제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.</li>
                <li>회사는 암호화 알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치를 채택하고 있습니다.</li>
                <li>해킹 등 외부침입에 대비하여 각 서버마다 침입탐지 및 침입차단시스템 등을 이용하여 보안에 만전을 기하고 있습니다. 회사는 해킹 등에 의한 정보의 유출을 방지하기 위해 침입차단시스템(방화벽)을 이용하여
                    외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적인 보안성을 확보하기 위해 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.</li>
            </ul>

            <h3 className="privacy-sub-title">2. 관리적 보호조치</h3>
            <ul>
                <li>회사는 귀하의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있습니다. 그 최소한의 인원에 해당하는 자는 다음과 같습니다.
                    <ul>
                        <li>이용자의 불만 및 이용문의 처리 업무를 수행하는 자</li>
                        <li>개인정보보호책임자 및 담당자 등 개인정보관리업무를 수행하는 자</li>
                        <li>기타 업무상 개인정보의 처리가 불가피한 자</li>
                    </ul>
                </li>
                <li>입사 시 전 직원의 보안서약서를 통하여 사람에 의한 정보유출을 사전에 방지하고 개인정보처리방침에 대한 이행사항 및 직원의 준수여부를 감사하기 위한 내부절차를 마련하고 있습니다.</li>
                <li>개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을 명확화하고 있습니다.</li>
                <li>회사는 이용자의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 이용자는 본인의 개인정보를 보호하기 위해서 자신의 아이디와 비밀번호를 적절하게 관리하고 여기에 대한 책임을
                    져야 합니다.</li>
                <li>그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실, 유출, 변조, 훼손이 유발될 경우 회사는 즉각 귀하께 사실을 알리고 적절한 대책과 보상을 강구할 것입니다.</li>
                <li>또한 회사는 국내 및 국제 정보보호 관리 체계 인증을 획득하였으며, 매년 독립된 심사 기관으로부터 기준 대비 충족 여부를 심사 받아 유지하고 있습니다.</li>
            </ul>

            {/* ── 8. 개인위치정보 ── */}
            <h2 className="privacy-section-title">8. 개인위치정보의 처리</h2>
            <p>회사는 위치정보의 보호 및 이용 등에 관한 법률에 따라 이용자의 개인위치정보를 안전하게 관리합니다.</p>

            <h3 className="privacy-sub-title">1. 개인위치정보의 처리목적 및 보유기간</h3>
            <ul>
                <li>회사는 이용자에게 '실시간 위치확인' 및 '현 위치 주변의 배달 및 매장 정보 제공'을 위한 목적으로 이용자 개인위치정보를 처리합니다. 이용 및 제공 목적 달성 시 지체없이 파기합니다. 다만, 이용자가 작성한 게시물
                    또는 콘텐츠와 함께 위치정보가 저장되는 서비스의 경우 해당 게시물 또는 콘텐츠의 보관기간 동안 개인위치정보가 보관됩니다. 이 외 자세한 사항은 위치서비스 이용약관 제 10조를 따릅니다.</li>
            </ul>

            <h3 className="privacy-sub-title">2. 개인위치정보 수집·이용·제공사실 확인자료의 보유근거 및 보유기간</h3>
            <ul>
                <li>회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 이용자의 민원처리 등을 위한 위치정보 이용, 제공 사실 확인자료를 자동 기록, 보존하며 해당 자료는 6개월 이상 보관합니다.</li>
            </ul>

            <h3 className="privacy-sub-title">3. 개인위치정보의 파기 절차 및 방법</h3>
            <ul>
                <li>회사는 개인위치정보의 처리목적이 달성된 경우, 개인위치정보를 재생이 불가능한 방법으로 안전하게 파기하고 있습니다. 전자적 파일 형태는 복구 및 재생이 불가능한 기술적인 방법으로 파기하며, 출력물 등은
                    분쇄하거나 소각하는 등의 방식으로 파기합니다.</li>
            </ul>

            <h3 className="privacy-sub-title">4. 개인위치정보의 제3자 제공 및 통보에 관한 사항</h3>
            <p>회사는 개인위치정보를 제3자에게 제공하지 않고 있습니다. 향후 개인위치정보주체가 지정한 제3자에게 제공이 필요한 경우에는 아래와 같은 조치를 취합니다.</p>
            <ul>
                <li>회사는 이용자의 동의 없이 당해 이용자의 개인위치정보를 제3자에게 제공하지 아니하며, 제3자에게 제공하는 경우 제공받는 자 및 제공 목적을 이용자에게 사전 고지하고 미리 동의를 받습니다.</li>
                <li>회사는 체결된 계약을 수행하기 위해 지정된 제3자에게 개인위치정보를 제공하는 경우, 개인위치정보를 수집한 당해 통신단말장치로 이용자에게 제공받는 자 및 제공목적을 즉시 통보합니다. 다만 아래 각호에 해당하는
                    경우 이용자가 미리 지정한 전자우편 또는 온라인 게시 등의 방법으로 통보할 수 있습니다.</li>
                <li>개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신 기능을 갖추지 아니한 경우</li>
                <li>이용자가 온라인 게시 등의 방법으로 통보할 것을 미리 요청한 경우</li>
            </ul>

            <h3 className="privacy-sub-title">5. 8세 이하 아동 등의 보호의무자의 권리의무 및 그 행사방법</h3>
            <ul>
                <li>회사는 14세 미만의 이용자에 대해서는 회원가입 및 서비스 이용이 불가합니다.</li>
                <li>회사는 아래의 경우에 해당하는 자(이하 8세 이하의 아동등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로
                    봅니다.
                    <ul>
                        <li>8세 이하의 아동</li>
                        <li>피성년후견인</li>
                        <li>장애인복지법 제2조 제2항 제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진 및 직업재활법 제2조 제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인
                            등록을 한 자에 한한다.)</li>
                    </ul>
                </li>
                <li>8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.</li>
                <li>보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.</li>
            </ul>

            <h3 className="privacy-sub-title">6. 위치정보 관리책임자 및 담당부서</h3>
            <ul>
                <li>회사의 위치정보 관리책임자 및 담당부서는 본 개인정보처리방침 "9. 개인정보 보호책임자 및 담당부서"에 기재된 정보와 동일합니다.</li>
            </ul>

            {/* ── 9. 보호책임자 ── */}
            <h2 className="privacy-section-title">9. 개인정보 보호책임자 및 담당 부서</h2>
            <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 개인정보 열람청구를 아래의 부서에 할 수
                있습니다.</p>
            <h3 className="privacy-sub-title">1. 개인정보 보호책임자</h3>
            <ul>
                <li>책임자 : 손지훈</li>
                <li>부서 : 3PL사업팀</li>
                <li>이메일 : license@vroongriders.com</li>
            </ul>
            <p>이용자는 회사가 제공하는 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의할 수 있으며, 회사는 이용자의 문의에 대해 지체없이 답변 및 처리할
                것입니다.</p>

            <h3 className="privacy-sub-title">권익침해 구제방법</h3>
            <p>기타 개인정보침해에 대한 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.</p>
            <ul>
                <li>개인정보 침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)</li>
                <li>개인정보 분쟁조정위원회 : 1833-6972 (kopico.go.kr)</li>
                <li>대검찰청 : (국번없이) 1301 (spo.go.kr)</li>
                <li>경찰청 사이버범죄 신고시스템(ECRM) : (국번없이) 182 (ecrm.police.go.kr)</li>
            </ul>

            {/* ── 10. 변경 고지 ── */}
            <h2 className="privacy-section-title">10. 개인정보 처리방침 변경 고지</h2>
            <p>본 개인정보처리방침은 시행일로부터 적용되며, 회사는 위 내용에 대한 추가, 삭제 및 변경이 있을 경우 개정내용이 시행되기 최소 7일 이전부터 공지사항 등을 통해 고지할 것입니다.</p>
            <ul>
                <li>개인정보처리방침 공고일자 : 2026.06.18</li>
                <li>개인정보처리방침 시행일자 : 2026.06.25</li>
            </ul>
            <p className="privacy-effective-date">이 개인정보처리방침은 2026년 06월 25일부터 적용됩니다.</p>
        </div>
    );
};

export default PrivacyPolicyPage;
